import React from 'react';
import PropTypes from 'prop-types';
import ProductFilter from '../../common/menu/products-filter';
import Products from './products';

export const CategoryModelPropTypes = {
    id: PropTypes.number.isRequired,
    backend_name: PropTypes.string.isRequired,
    description: PropTypes.string,
    name: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    image_src: PropTypes.string,
    getProducts: PropTypes.func.isRequired,
};

class Category extends React.Component {
    static propTypes = {
        entity: PropTypes.shape(CategoryModelPropTypes).isRequired,
        is_selected: PropTypes.bool.isRequired,
    };

    constructor(...args) {
        super(...args);

        this.state = {
            min_height: null,
        };
    }

    getProductNodes = () => {
        if (this.products_root) {
            return this.products_root.getProductNodes();
        }
        return {};
    };

    setProductMinHeight = min_height => {
        if (min_height === this.state.min_height) {
            return;
        }
        this.setState({
            min_height,
        });
    };

    render() {
        const { min_height } = this.state;
        const { entity: category, is_selected } = this.props;
        const {
            id,
            backend_name,
            description,
            tags,
            name,
            image_src,
        } = category;
        const products = ProductFilter(category.getProducts().toArray());
        return (
            <div
                id={`m2g-menu-category-${backend_name}`}
                data-category={id}
                data-category-name={backend_name}
                data-tags={tags.join('')}
                className={`m2g-menu-category ${
                    is_selected ? 'm2g-menu-category--selected' : ''
                }`}
            >
                <div className="m2g-menu-category-info">
                    <div className="m2g-menu-category-title">
                        <h3
                            className="m2g-h3 m2g-menu-category-name m2g-title-text"
                            dangerouslySetInnerHTML={{ __html: name }}
                        />
                        {description && (
                            <span
                                className="m2g-menu-category-description m2g-text--offset m2g-custom-html"
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        )}
                    </div>
                    {image_src && (
                        <img
                            className="m2g-menu-category-image m2g-image"
                            src={image_src}
                        />
                    )}
                </div>
                <Products
                    data={products}
                    min_height={min_height}
                    ref={e => (this.products_root = e)}
                />
                <div className="m2g-clearfix" />
            </div>
        );
    }
}

export default Category;
